export const STORAGE_KEYS = {
  sources: "newsAppActiveSources",
  read: "newsAppReadLinks",
  readSources: "newsAppReadSources",
  sourceReadCutoffs: "newsAppSourceReadCutoffs",
  unreadCountSince: "newsAppUnreadCountSince",
  unreadModelVersion: "newsAppUnreadModelVersion",
  unreadReadItems: "newsAppUnreadReadItems",
  unreadCommittedItems: "newsAppUnreadCommittedItems",
  unreadReadAllBaselines: "newsAppUnreadReadAllBaselines",
  unreadSuppressedBackfillSessions: "newsAppUnreadSuppressedBackfillSessions",
  saved: "savedNewsLinks",
  savedItems: "savedNewsItems",
  deferredInsertNews: "newsAppDeferredInsertNews",
};

const DEFAULT_NEWS_API_URL = "http://localhost/news_api/api.php";

const getNewsApiUrl = () => {
  const envApiUrl = process.env.REACT_APP_NEWS_API_URL?.trim();

  return envApiUrl || DEFAULT_NEWS_API_URL;
};

const getShareBaseUrl = () => {
  const envShareBaseUrl = process.env.REACT_APP_SHARE_BASE_URL?.trim();

  return String(envShareBaseUrl || "").replace(/\/+$/, "");
};

export const NEWS_CONFIG = {
  initialBatchSize: 100,
  insertPollingBatchSize: 200,
  largeBacklogThreshold: 500,
  homeInitialVisibleBatchSize: 20,
  focusSourceInitialBatchSize: 20,
  loadMoreBatchSize: 20,
  loadMoreSkeletonDelayMs: 220,
  refreshIntervalMs: 30000,
  connectionProbeIntervalMs: 3000,
  mostVisitedRefreshIntervalMs: 10 * 60 * 1000,
  retryDelaysMs: [2000, 5000, 10000, 30000],
  requestTimeoutsMs: {
    initial: 12000,
    polling: 8000,
    connectionProbe: 5000,
    loadMore: 10000,
    sourceMetadata: 8000,
    mostVisited: 10000,
    sharedNews: 10000,
    recordView: 5000,
  },
  mostVisitedLimit: 10,
  sharePathPrefix: "/news/",
  shareBaseUrl: getShareBaseUrl(),
  apiUrl: getNewsApiUrl(),
};

export const MOST_VISITED_FILTERS = ["24h", "week", "month"];
